<template>
  <div class="base">
      <div id="Dashboard" v-if="!Loading">
      <div class="widget" v-if="$store.state.Widget1_Get.Status">
            <div class="item">
                <h3> پروژه/شهر</h3>
                <span>(تعداد)</span>
                <h1 v-text="$store.state.Widget1_Get.RequestResponse[0].Projects.toString().replace(/\d/g, d => '۰۱۲۳۴۵۶۷۸۹'[d])"></h1>
            </div>
            <div class="item">
              <h3>خودرو</h3>
              <span>(تعداد)</span>
              <h1 v-text="$store.state.Widget1_Get.RequestResponse[0].Vehicles.toString().replace(/\d/g, d => '۰۱۲۳۴۵۶۷۸۹'[d])"></h1>
            </div>
            <div class="item">
              <h3>خطوط</h3>
              <span>(تعداد)</span>
              <h1 v-text="$store.state.Widget1_Get.RequestResponse[0].Lines.toString().replace(/\d/g, d => '۰۱۲۳۴۵۶۷۸۹'[d])"></h1>
            </div>
            <div class="item">
              <h3>طول خطوط</h3>
              <span>(کیلومتر)</span>
              <h1 v-text="$store.state.Widget1_Get.RequestResponse[0].PathLength.toString().replace(/\d/g, d => '۰۱۲۳۴۵۶۷۸۹'[d])"></h1>
            </div>
      </div>
       <div class="widget5" >
         <div class="item1">
           <h2>خودرو ها به تفکیک نوع</h2>
            <MCHartPie 
                 :keyV="0" :dataset="widget5_1_Data_1()"
                  :dataset2="widget5_1_Data_2()"
                  :labels="widget5_1_Label_1()" :labels2="widget5_1_Label_2()" ></MCHartPie>
         </div>
         <div class="item2">
           <h2>خودرو ها به تفکیک نوع سوخت</h2>
           <br>
           <CChartPie
              v-if="$store.state.Widget5_Get.Status"
              :labels="['گاز طبیعی','دیزل']"
              :options="defaultOptions4"
              :datasets="[
                {
                  backgroundColor: [
                    '#5C84CC',
                    '#8FAADC',
                  ],
                  data: [$store.state.Widget5_Get.Data_1[0].Gas, $store.state.Widget5_Get.Data_1[0].Diesel]
                }
              ]"
            />
         </div>
         <div class="item3">
           <h2>خودرو ها به تفکیک طول عمر</h2>
           <br>
            <CChartPie
            v-if="$store.state.Widget5_Get.Status"
            :options="defaultOptions4"
              :labels="['زیر 5سال ', 'بین 5 تا 10سال', 'بین 10 تا 15سال', 'بیش از 15سال']"
              :datasets="[
                {
                  backgroundColor: [
                    '#61B378',
                    '#83C395',
                    '#FFC000',
                    '#FFA7A7'
                  ],
                  data: [$store.state.Widget5_Get.Data_2[0].Below5Years, $store.state.Widget5_Get.Data_2[0]['5To10Years'], $store.state.Widget5_Get.Data_2[0]['10To15Years'], $store.state.Widget5_Get.Data_2[0].Up15Years]
                }
              ]"
            />
         </div>
       </div>
      <div class="widget2">
            <div class="item1">
                <h2>تعداد خودرو در هر پروژه</h2>
                <CChartBar
                 v-if="$store.state.Widget2_Get.Status"
                  style="height:100%"
                  :datasets="[
                      {
                        data: [$store.state.Widget2_Get.RequestResponse[0].Shiraz,
                        $store.state.Widget2_Get.RequestResponse[0].Qaen,
                        $store.state.Widget2_Get.RequestResponse[0].ShahrKord,
                        $store.state.Widget2_Get.RequestResponse[0].Andishe],
                        backgroundColor: '#4472C4',
                        pointHoverBackgroundColor: '#4472C4',
                        label: 'تعداد',
                      }
                    ]"
                  :options="defaultOptions2"
                  :labels="['شیراز','قائن','شهر کرد','اندیشه']"
                />
            </div>
            <div class="item2">
              <h2>وضعیت اتصال خودرو</h2>
              <CChartBar
                  style="height:100%"
                  v-if="$store.state.Widget2_Get.Status"
                  :datasets="[
                      {
                        data: [$store.state.Widget2_Get.Data_1[0].Shiraz_Day,
                        $store.state.Widget2_Get.Data_1[0].Qaen_Day,
                        $store.state.Widget2_Get.Data_1[0].ShahrKord_Day,
                        $store.state.Widget2_Get.Data_1[0].Andishe_Day],
                        backgroundColor: '#4DA165',
                        pointHoverBackgroundColor: '#4DA165',
                        label: 'روز جاری',
                      },
                      {
                        data: [$store.state.Widget2_Get.Data_1[0].Shiraz_Week,
                        $store.state.Widget2_Get.Data_1[0].Qaen_Week,
                        $store.state.Widget2_Get.Data_1[0].ShahrKord_Week,
                        $store.state.Widget2_Get.Data_1[0].Andishe_Week],
                        backgroundColor: '#83C395',
                        pointHoverBackgroundColor: '#83C395',
                        label: 'هفته جاری',
                      },
                      {
                        data: [$store.state.Widget2_Get.Data_1[0].Shiraz_Month,
                        $store.state.Widget2_Get.Data_1[0].Qaen_Month,
                        $store.state.Widget2_Get.Data_1[0].ShahrKord_Month,
                        $store.state.Widget2_Get.Data_1[0].Andishe_Month],
                        backgroundColor: '#FFC000',
                        pointHoverBackgroundColor: '#FFC000',
                        label: 'ماه جاری',
                      },
                      {
                        data: [$store.state.Widget2_Get.Data_1[0].Shiraz_PreMonth,
                        $store.state.Widget2_Get.Data_1[0].Qaen_PreMonth,
                        $store.state.Widget2_Get.Data_1[0].ShahrKord_PreMonth,
                        $store.state.Widget2_Get.Data_1[0].Andishe_PreMonth],
                        backgroundColor: '#FFA7A7',
                        pointHoverBackgroundColor: '#FFA7A7',
                        label: 'پیش از ماه جاری',
                      }
                    ]"
                  :options="defaultOptions3"
                  :labels="['شیراز','قائن','شهر کرد','اندیشه']"
                />
            </div>
            <div class="item3">
              <h2>روند فعالیت خودرو</h2>
              <CChartLine
              v-if="$store.state.Widget2_Get.Status"
               style="height:270px;"
                :datasets="GetChartActivationData()"
                :options="defaultOptions"
                :labels="GetChartActivationLabel()"
            />
            </div>
      </div>
      <div class="widget3">
            <div class="item1">
                <h2>آخرین وضعیت خطوط</h2>
                <CChartBar
                v-if="$store.state.Widget3_Get.Status"
                  style="height:100%"
                  :datasets="[
                      {
                        data: [$store.state.Widget3_Get.RequestResponse[0].Shiraz_Line,
                        $store.state.Widget3_Get.RequestResponse[0].Qaen_Line,
                        $store.state.Widget3_Get.RequestResponse[0].ShahrKord_Line,
                        $store.state.Widget3_Get.RequestResponse[0].Andishe_Line],
                        backgroundColor: '#4472C4',
                        pointHoverBackgroundColor: '#4472C4',
                        label: 'تعداد خطوط',
                      },
                      {
                        data: [$store.state.Widget3_Get.RequestResponse[0].Shiraz_AvgVehicle,
                        $store.state.Widget3_Get.RequestResponse[0].Qaen_AvgVehicle,
                        $store.state.Widget3_Get.RequestResponse[0].ShahrKord_Line,
                        $store.state.Widget3_Get.RequestResponse[0].Andishe_AvgVehicle],
                        backgroundColor: '#000000',
                        pointHoverBackgroundColor: '#000000',
                        label: 'میانگین تعداد خودرو در هر خط',
                      }
                    ]"
                  :options="defaultOptions2"
                  :labels="['شیراز','قائن','شهر کرد','اندیشه']"
                />
            </div>
            <div class="item2">
              <h2>روند ظرفیت فعال خطوط</h2>
              <CChartLine
                :datasets="GetChartActivationData2()"
                :options="defaultOptions"
                
                style="width:100%;height:270px;"
                :labels="GetChartActivationLabel2()"
            />
            </div>
      </div>
      <div class="widget4" >
            <div class="item1">
                <h2>خودرو با قابلیت ارسال داده به سامانه سیپاد</h2>
                <MCHartPie 
                 :keyV="1" :dataset="widget4_1_Data_1()"
                  :dataset2="widget4_1_Data_2()"
                  :labels="widget4_1_Label_1()" :labels2="widget4_1_Label_2()" ></MCHartPie>
            </div>
            <div class="item2">
              <h2>وضعیت ارسال داده پیمایش به سامانه سیپاد</h2>
              <CChartBar
              v-if="$store.state.Widget4_Get.Status"
                  style="height:100%"
                  :datasets="[
                      {
                        data: [$store.state.Widget4_Get.Data_1[0].Shiraz_Send,
                        $store.state.Widget4_Get.Data_1[0].Qaen_Send,
                        $store.state.Widget4_Get.Data_1[0].SharKord_Send,
                        $store.state.Widget4_Get.Data_1[0].Andishe_Send],
                        backgroundColor: '#4DA165',
                        pointHoverBackgroundColor: '#4DA165',
                        label: 'ارسال‌موفق',
                      },
                      {
                        data: [$store.state.Widget4_Get.Data_1[0].Shiraz_NoSend,
                        $store.state.Widget4_Get.Data_1[0].Qaen_NoSend,
                        $store.state.Widget4_Get.Data_1[0].SharKord_NoSend,
                        $store.state.Widget4_Get.Data_1[0].Andishe_NoSend],
                        backgroundColor: '#FFA7A7',
                        pointHoverBackgroundColor: '#FFA7A7',
                        label: 'ارسال‌ناموفق',
                      },
                    ]"
                  :options="defaultOptions3"
                  :labels="['شیراز','قائن','شهر کرد','اندیشه']"
                />
            </div>
            <div class="item3">
              <h2>میانگین پیمایش هر خودرو در پروژه(کیلومتر)</h2>
              <CChartLine
              v-if="$store.state.Widget4_Get.Status"
                :datasets="GetChartActivationData3()"
                :options="defaultOptions"
                
                style="height:270px;"
                :labels="GetChartActivationLabel3()"
            />
            </div>
      </div>
      <div class="widget6">
          <div class="item">
              <h2>پروژه شیراز</h2>
              <br>
              <br>
              <CButton color="outline-info" @click="OPenLink('https://bms.shiraz.ir/#/User/login')">
                مشاهده
                &nbsp;
                <CIcon name="cil-external-link" width="20px"></CIcon>
                
              </CButton>
              <div style="display:flex;direction:ltr">
                
              </div>
          </div>
          <div class="item">
            <h2>پروژه قائن</h2>
            <br>
              <br>
            <CButton color="outline-info" disabled >
                مشاهده
                &nbsp;
                <CIcon name="cil-external-link" width="20px"></CIcon>
                
              </CButton>
          </div>
          <div class="item">
            <h2>پروژه اندیشه</h2>
            <br>
              <br>
            <CButton color="outline-info" @click="OPenLink('http://andishe.tfms.ir/#/User/login')">
                مشاهده
                &nbsp;
                <CIcon name="cil-external-link" width="20px"></CIcon>
                
              </CButton>
          </div>
          <div class="item">
            <h2>پروژه شهرکرد</h2>
            <br>
              <br>
            <CButton color="outline-info" disabled>
                مشاهده
                &nbsp;
                <CIcon name="cil-external-link" width="20px"></CIcon>
                
              </CButton>
          </div>
      </div>
    </div>
  </div>
</template>

<script>
 import { CChartLine,CChartBar,CChartPie } from '@coreui/vue-chartjs'
 import { CChart } from '@coreui/vue-chartjs'
export default {
  name: 'Dashboard',
    components:{
      CChartLine,
      CChartBar,
      CChartPie,
      CChart
    },
    data(){
      return {
          
          
          Loading:false,  
      }
    },
    computed: {
      defaultOptions () {
        return {
          TimerActive:false,
          maintainAspectRatio: false,
          responsive:true,
          legend: {
            display: true,
            
            labels: {
              
            }
          },
          scales: {
            xAxes: [{
              gridLines: {
                drawOnChartArea: false
              },
              ticks: {
                // fontColor: "white",
              }
            }],
            yAxes: [{
              ticks: {
                beginAtZero: true,
                maxTicksLimit: 5,
                stepSize: Math.ceil(100 / 5),
                // fontColor: "white",
                display:false

              },
              gridLines: {
                display: true,

              }
            }],
            responsive: true,
            maintainAspectRatio: false,
            height: 300,
          },
          elements: {
            point: {
              radius: 1,
              hitRadius: 10,
              hoverRadius: 4,
              hoverBorderWidth: 3
            }
          },

        }
      },
      defaultOptions2 () {
        return {
          TimerActive:false,
          maintainAspectRatio: false,
          legend: {
            display: true,
            labels: {
              // fontColor: 'white',
            }
          },
          scales: {
            xAxes: [{
              barPercentage: 0.4,
              gridLines: {
                drawOnChartArea: false
              },
              ticks: {
                // fontColor: "white",
              }
            }],
            yAxes: [{
              ticks: {
                beginAtZero: true,
                maxTicksLimit: 5,
                stepSize: Math.ceil(100 / 5),
                // fontColor: "white",
                display:false

              },
              gridLines: {
                 drawOnChartArea: true,
                display: true,

              }
            }],

          },
          elements: {
            point: {
              radius: 1,
              hitRadius: 10,
              hoverRadius: 4,
              hoverBorderWidth: 3
            }
          },

        }
      },
      defaultOptions3 () {
        return {
          TimerActive:false,
          maintainAspectRatio: false,
          legend: {
            display: true,
            labels: {
              // fontColor: 'white',
            }
          },
          scales: {
            xAxes: [{
              barPercentage: 0.4,
              stacked: true,
              gridLines: {
                drawOnChartArea: false
              },
              ticks: {
                 //fontColor: "white",
              }
            }],
            yAxes: [{
              stacked: true,
              ticks: {
                beginAtZero: true,
                maxTicksLimit: 5,
                min: 0,
                max: 100,
                stepSize: Math.ceil(100 / 5),
                // fontColor: "white",
                display:false

              },
              gridLines: {
                 drawOnChartArea: true,
                display: true,

              }
            }],

          },
          elements: {
            point: {
              radius: 1,
              hitRadius: 10,
              hoverRadius: 4,
              hoverBorderWidth: 3
            }
          },

        }
      },
      defaultOptions4 () {
        return {
            legend: {
            display: true,
            position:'left',
            labels: {
              title:{
                font:'45px sansBold'
              },
              font:'45px sansBold'
            }
          },
          

        }
      },
      ReadSize(){
        return this.$store.state.sidebarMinimize;
      },
      ReadSidebarShow(){
        return this.$store.state.sidebarShow;
      }
    },
    watch:{
      ReadSize(state){
        this.Loading=true;
        this.$store.state.Loading.Dashboard=true;
        var that=this;
        setTimeout(function() {
              that.Loading=false;
              that.$store.state.Loading.Dashboard=false;
        }, 300);
      },
      ReadSidebarShow(state){
        this.Loading=true;
        this.$store.state.Loading.Dashboard=true;
        var that=this;
        setTimeout(function() {
              that.Loading=false;
              that.$store.state.Loading.Dashboard=false;
        }, 300);
      }
    },
    mounted(){
      //CChartBar.register(ChartDataLabels);
      this. Widget1_Get();
      this. Widget2_Get();
      this. Widget3_Get();
      this. Widget4_Get();
      this. Widget5_Get();
    },
    methods:{
      GetChartActivationData(){
        var data=[];
        var dat1={
              data: [],
              label: 'معیار',
              pointHoverBackgroundColor: '#70AD47',
              borderColor: '#70AD47',
              backgroundColor: '#0000FF00',
              labelColor:"#70AD47",
              Color:"#70AD47",
              borderWidth: 3,
            };
        var dat2={
              data: [],
              label: 'شیراز',
              pointHoverBackgroundColor: '#203864',
              borderColor: '#203864',
              backgroundColor: '#0000FF00',
              labelColor:"#203864",
              Color:"#203864",
              borderWidth: 3,
            };
        var dat3={
              data: [],
              label: 'قائن',
              pointHoverBackgroundColor: '#4472C4',
              borderColor: '#4472C4',
              backgroundColor: '#0000FF00',
              labelColor:"#4472C4",
              Color:"#4472C4",
              borderWidth: 3,
            };
        var dat4={
              data: [],
              label: 'شهرکرد',
              pointHoverBackgroundColor: '#B4C7E7 ',
              borderColor: '#B4C7E7',
              backgroundColor: '#0000FF00',
              labelColor:"#B4C7E7",
              Color:"#B4C7E7",
              borderWidth: 3,
            };
        var dat5={
              data: [],
              label: 'اندیشه',
              pointHoverBackgroundColor: '#A5A5A5',
              borderColor: '#A5A5A5',
              backgroundColor: '#0000FF00',
              labelColor:"#A5A5A5",
              Color:"#A5A5A5",
              borderWidth: 3,
            };
          for(var i=0;i<this.$store.state.Widget2_Get.Data_2.length;i++){
            dat1.data.push(80)
            dat2.data.push(this.$store.state.Widget2_Get.Data_2[i].Shiraz)
            dat3.data.push(this.$store.state.Widget2_Get.Data_2[i].Qaen)
            dat4.data.push(this.$store.state.Widget2_Get.Data_2[i].ShahrKord)
            dat5.data.push(this.$store.state.Widget2_Get.Data_2[i].Andishe)
          }
          data.push(dat1);
          data.push(dat2);
          data.push(dat3);
          data.push(dat4);
          data.push(dat5);
        return data;
      },
      GetChartActivationLabel(){
        var labels=[];
        labels.push('1402 آبان 17');
        labels.push('1402 آبان 18');
        labels.push('1402 آبان 19');
        labels.push('1402 آبان 20');
        labels.push('1402 آبان 21');
        labels.push('1402 آبان 22');
        labels.push('1402 آبان 23');
        labels.push()
        return labels;
      },
      GetChartActivationData2(){
        var data=[];
        var dat1={
              data: [],
              label: 'معیار',
              pointHoverBackgroundColor: '#70AD47',
              borderColor: '#70AD47',
              backgroundColor: '#0000FF00',
              labelColor:"#70AD47",
              Color:"#70AD47",
              borderWidth: 3,
            };
        var dat2={
              data: [],
              label: 'شیراز',
              pointHoverBackgroundColor: '#203864',
              borderColor: '#203864',
              backgroundColor: '#0000FF00',
              labelColor:"#203864",
              Color:"#203864",
              borderWidth: 3,
            };
        var dat3={
              data: [],
              label: 'قائن',
              pointHoverBackgroundColor: '#4472C4',
              borderColor: '#4472C4',
              backgroundColor: '#0000FF00',
              labelColor:"#4472C4",
              Color:"#4472C4",
              borderWidth: 3,
            };
        var dat4={
              data: [],
              label: 'شهرکرد',
              pointHoverBackgroundColor: '#B4C7E7 ',
              borderColor: '#B4C7E7',
              backgroundColor: '#0000FF00',
              labelColor:"#B4C7E7",
              Color:"#B4C7E7",
              borderWidth: 3,
            };
        var dat5={
              data: [],
              label: 'اندیشه',
              pointHoverBackgroundColor: '#A5A5A5',
              borderColor: '#A5A5A5',
              backgroundColor: '#0000FF00',
              labelColor:"#A5A5A5",
              Color:"#A5A5A5",
              borderWidth: 3,
            };

        for(var i=0;i<this.$store.state.Widget3_Get.Data_1.length;i++){
            dat1.data.push(80)
            dat2.data.push(this.$store.state.Widget3_Get.Data_1[i].Shiraz)
            dat3.data.push(this.$store.state.Widget3_Get.Data_1[i].Qaen)
            dat4.data.push(this.$store.state.Widget3_Get.Data_1[i].ShahrKord)
            dat5.data.push(this.$store.state.Widget3_Get.Data_1[i].Andishe)
          }
          data.push(dat1);
          data.push(dat2);
          data.push(dat3);
          data.push(dat4);
          data.push(dat5);
        return data;
      },
      GetChartActivationLabel2(){
        var labels=[];
        labels.push('فروردین');
        labels.push('اردیبهشت');
        labels.push('خرداد');
        labels.push('تیر');
        labels.push('مرداد');
        labels.push('شهریور');
        labels.push('مهر');
        labels.push('آبان');
        labels.push('آذر');
        labels.push('دی');
        labels.push('بهمن');
        labels.push('اسفند');
        return labels;
      },
      GetChartActivationData3(){
        var data=[];
        var dat2={
              data: [],
              label: 'شیراز',
              pointHoverBackgroundColor: '#203864',
              borderColor: '#203864',
              backgroundColor: '#0000FF00',
              labelColor:"#203864",
              Color:"#203864",
              borderWidth: 3,
            };
        var dat3={
              data: [],
              label: 'قائن',
              pointHoverBackgroundColor: '#4472C4',
              borderColor: '#4472C4',
              backgroundColor: '#0000FF00',
              labelColor:"#4472C4",
              Color:"#4472C4",
              borderWidth: 3,
            };
        var dat4={
              data: [],
              label: 'شهرکرد',
              pointHoverBackgroundColor: '#B4C7E7 ',
              borderColor: '#B4C7E7',
              backgroundColor: '#0000FF00',
              labelColor:"#B4C7E7",
              Color:"#B4C7E7",
              borderWidth: 3,
            };
        var dat5={
              data: [],
              label: 'اندیشه',
              pointHoverBackgroundColor: '#A5A5A5',
              borderColor: '#A5A5A5',
              backgroundColor: '#0000FF00',
              labelColor:"#A5A5A5",
              Color:"#A5A5A5",
              borderWidth: 3,
            };

        for(var i=0;i<this.$store.state.Widget4_Get.Data_2.length;i++){
            dat2.data.push(this.$store.state.Widget4_Get.Data_2[i].Shiraz)
            dat3.data.push(this.$store.state.Widget4_Get.Data_2[i].Qaen)
            dat4.data.push(this.$store.state.Widget4_Get.Data_2[i].ShahrKord)
            dat5.data.push(this.$store.state.Widget4_Get.Data_2[i].Andishe)
          }
          data.push(dat2);
          data.push(dat3);
          data.push(dat4);
          data.push(dat5);
        return data;
      },
      GetChartActivationLabel3(){
        var labels=[];
        labels.push('فروردین');
        labels.push('اردیبهشت');
        labels.push('خرداد');
        labels.push('تیر');
        labels.push('مرداد');
        labels.push('شهریور');
        labels.push('مهر');
        labels.push('آبان');
        labels.push('آذر');
        labels.push('دی');
        labels.push('بهمن');
        labels.push('اسفند');
        return labels;
      },


      
      widget5_1_Data_1(){
        var data=[this.$store.state.Widget5_Get.RequestResponse[0].Youtang,
        this.$store.state.Widget5_Get.RequestResponse[0].Scania
        ,this.$store.state.Widget5_Get.RequestResponse[0].Benz457
        ,this.$store.state.Widget5_Get.RequestResponse[0].Atros
        ,this.$store.state.Widget5_Get.RequestResponse[0].Cruise];
        return data;
      },
      widget5_1_Data_2(){
        var data=[this.$store.state.Widget5_Get.RequestResponse[0].TotalBus,
        this.$store.state.Widget5_Get.RequestResponse[0].TotalMiniBus];
        return data;
      },
      widget5_1_Label_1(){
        var labels= [
              {color:'#7B7B7B',label:'یوتانگ',key:0},
              {color:'#929292',label:'اسکانیا',key:1},
              {color:'#A5A5A5',label:'بنز 457' ,key:2},
              {color:'#BFBFBF',label:'آتروس',key:3},
              {color:'#D5D5D5',label:'هیوندای کروز',key:4},
            ];
            return labels;
      },
      widget5_1_Label_2(){
        var labels= [
              {color:'#5C84CC',label:'اتوبوس' ,key:0},
              {color:'#8FAADC',label:'مینی بوس',key:1},
             
            ];
        return labels;
      },
      widget4_1_Data_1(){
        var data=[
        this.$store.state.Widget4_Get.RequestResponse[0].Shiraz_Send,
        this.$store.state.Widget4_Get.RequestResponse[0].Shiraz_NoSend,
        this.$store.state.Widget4_Get.RequestResponse[0].Qaen_Send,
        this.$store.state.Widget4_Get.RequestResponse[0].Qaen_NoSend,
        this.$store.state.Widget4_Get.RequestResponse[0].SharKord_Send,
        this.$store.state.Widget4_Get.RequestResponse[0].SharKord_NoSend,
        this.$store.state.Widget4_Get.RequestResponse[0].Andishe_Send,
        this.$store.state.Widget4_Get.RequestResponse[0].Andishe_NoSend
        ];
        return data;
      },
      widget4_1_Data_2(){
        var data=[this.$store.state.Widget4_Get.RequestResponse[0].Shiraz,
        this.$store.state.Widget4_Get.RequestResponse[0].Qaen,
        this.$store.state.Widget4_Get.RequestResponse[0].SharKord,
        this.$store.state.Widget4_Get.RequestResponse[0].Andishe
        ];
        return data;
      },
      widget4_1_Label_1(){
        var labels= [
              {color:'#4DA165',label:'قابل ارسال' ,key:0},
              {color:'#FFA7A7',label:'غیر قابل ارسال',key:1},
              {color:'#4DA165',label:'قابل ارسال',key:0},
              {color:'#FFA7A7',label:'غیر قابل ارسال',key:1},
              {color:'#4DA165',label:'قابل ارسال',key:0},
              {color:'#FFA7A7',label:'غیر قابل ارسال',key:1},
              {color:'#4DA165',label:'قابل ارسال',key:0},
              {color:'#FFA7A7',label:'غیر قابل ارسال',key:1},
            ];
            return labels;
      },
      widget4_1_Label_2(){
        var labels=[
              {color:'#44546A',label:'َشیراز' ,key:0},
              {color:'#5B9BD5',label:'قائن',key:1},
              {color:'#4472C4',label:'شهرکرد',key:0},
              {color:'#A5A5A5',label:'اندیشه',key:1},
             
            ];
        return labels;
      },
      OPenLink(link){
        window.open(link,'_target')
      },
      Widget1_Get(){
        this.$store.commit('Widget1_Get');
      },
      Widget2_Get(){
        this.$store.commit('Widget2_Get');
      },
      Widget3_Get(){
        this.$store.commit('Widget3_Get');
      },
      Widget4_Get(){
        this.$store.commit('Widget4_Get');
      },
      Widget5_Get(){
        this.$store.commit('Widget5_Get');
      },
    }

}
</script>

<style>

</style>